import * as lvFlandersBarNgAgGrid from '../dist/@lvflanders/bar-ng-ag-grid';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].bar == null) window['lvflanders'].bar = <any>{};
if (window['lvflanders'].bar.ng == null) window['lvflanders'].bar.ng = <any>{};

window['lvflanders'].bar.ng.agGrid = lvFlandersBarNgAgGrid;

export { lvFlandersBarNgAgGrid };